(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product_video_carousel"] && !Shopify.designMode) return;
  try {
    class CaProductVideoCarousel extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.carousel = this.querySelector("ca-carousel");
      this.toggle = this.querySelector("[data-product-video-toggle]");
      this.motionPreference = window.matchMedia?.("(prefers-reduced-motion: reduce)");
      this.userPaused = !this.hasAttribute("auto-rotate");
      this.pointerPaused = false;
      this.focusPaused = false;
      this.inViewport = true;

      this.toggle?.addEventListener("click", () => {
        this.userPaused = !this.userPaused;
        if (!this.userPaused) this.focusPaused = false;
        this.sync();
      }, { signal });

      this.addEventListener("pointerenter", () => {
        this.pointerPaused = true;
        this.schedule();
      }, { signal });

      this.addEventListener("pointerleave", () => {
        this.pointerPaused = false;
        this.schedule();
      }, { signal });

      this.addEventListener("focusin", () => {
        this.focusPaused = true;
        this.schedule();
      }, { signal });

      this.addEventListener("focusout", (event) => {
        if (event.relatedTarget instanceof Node && this.contains(event.relatedTarget)) return;
        this.focusPaused = false;
        this.schedule();
      }, { signal });

      this.carousel?.addEventListener("ca-carousel:select", () => this.schedule(), { signal });
      this.motionPreference?.addEventListener?.("change", () => this.sync(), { signal });
      document.addEventListener("visibilitychange", () => this.schedule(), { signal });

      if ("IntersectionObserver" in window) {
        this.viewportObserver = new IntersectionObserver(([entry]) => {
          this.inViewport = entry.isIntersecting;
          this.schedule();
        });
        this.viewportObserver.observe(this);
      }

      this.sync();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      this.viewportObserver?.disconnect();
      this.viewportObserver = null;
      window.clearTimeout(this.rotationTimer);
      this.rotationTimer = null;
    }

    sync() {
      const motionReduced = this.motionPreference?.matches || false;
      const paused = this.userPaused || motionReduced;

      if (this.toggle) {
        this.toggle.hidden = motionReduced;
        this.toggle.setAttribute("aria-pressed", String(paused));
        this.toggle.setAttribute(
          "aria-label",
          paused ? this.dataset.playLabel : this.dataset.pauseLabel,
        );
        const pauseIcon = this.toggle.querySelector("[data-product-video-pause-icon]");
        const playIcon = this.toggle.querySelector("[data-product-video-play-icon]");
        if (pauseIcon) pauseIcon.hidden = paused;
        if (playIcon) playIcon.hidden = !paused;
      }

      this.schedule();
    }

    schedule() {
      window.clearTimeout(this.rotationTimer);
      this.rotationTimer = null;

      const motionReduced = this.motionPreference?.matches || false;
      const canRotate =
        !this.userPaused &&
        !this.pointerPaused &&
        !this.focusPaused &&
        !motionReduced &&
        this.inViewport &&
        !document.hidden;
      if (!canRotate) return;

      const configuredInterval = Number.parseInt(this.getAttribute("rotation-interval"), 10);
      const interval = Number.isFinite(configuredInterval) ? Math.max(3000, configuredInterval) : 5000;
      this.rotationTimer = window.setTimeout(() => {
        this.carousel?.embla?.scrollNext();
        this.schedule();
      }, interval);
    }
  }

  if (!customElements.get("ca-product-video-carousel")) {
    customElements.define("ca-product-video-carousel", CaProductVideoCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
